import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import {
  SocialExportListConnectionsQueryParamsPlatformEnumKey,
  useSocialExportListConnections,
} from '@mi-front/api-v2';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { ConnectionsManageContent } from './ConnectionsManageContent';
import { ConnectionsManageSkeleton } from './ConnectionsManageSkeleton';
import { useRedirectToConnectionSettingsOnSuccess } from './useRedirectToConnectionSettingsOnSuccess';

type Props = {
  platform: SocialPlatform;
};

/**
 * Connection-first manage view: list of client connections + detail panel for the selection.
 */
export function ConnectionsManageView({ platform }: Props) {
  // OAuth callbacks land here; forward successful connects to connection settings.
  useRedirectToConnectionSettingsOnSuccess(platform.id);

  const connectionsQuery = useSocialExportListConnections({
    platform: platform.id as SocialExportListConnectionsQueryParamsPlatformEnumKey,
  });

  return (
    <QueryView inline query={connectionsQuery} loader={<ConnectionsManageSkeleton />}>
      {(data) => <ConnectionsManageContent platform={platform} connections={data.results} />}
    </QueryView>
  );
}
